export const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

// 解析参考文献
export function parseReferences(text) {
    const references = [];
    // 移除可能的开头空白字符
    const cleanText = text.trim();
    const textLength = cleanText.length;

    // 根据文本长度确定最大允许的文献数量
    let maxReferences = 20; // 默认10000字以内20条
    if (textLength > 15000) {
        maxReferences = 10; // 超过15000字限制10条
    } else if (textLength > 10000) {
        maxReferences = 15; // 超过10000字限制15条
    }

    // 简单地用 [数字] 作为分隔符来分割文本
    const entries = cleanText.split(/(?=\[\d+\])/);

    for (const entry of entries) {
        // 如果已达到最大引用数量限制，停止解析
        if (references.length >= maxReferences) break;

        const trimmedEntry = entry.trim();
        // 跳过空条目或不以 [数字] 开头的条目
        if (!trimmedEntry || !/^\[\d+\]/.test(trimmedEntry)) continue;

        try {
            // 用摘要来分割获取引文信息和摘要部分
            const parts = trimmedEntry.split(/摘要[:：]/);
            if (parts.length < 2) continue;

            // 去掉引文信息前面的 [数字]
            const _references = parts[0].trim().replace(/^\[\d+\]\s*/, '');
            // 获取剩余所有内容作为摘要（以防有多个"摘要"关键词）
            const abstractContent = parts.slice(1).join('摘要：').trim();

            references.push({
                id: generateUUID(),
                references: _references,
                abstractContent,
                isCustom: true,
            });
        } catch (e) {
            console.error('解析引文时出错:', e.message);
            continue;
        }
    }

    return {
        references,
        totalLength: textLength,
        maxReferences,
    };
}
